module.exports = __webpack_public_path__ + "static/media/0858780b2c08bd1e370c06a031b86dda.a824228b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/0858780b2c08bd1e370c06a031b86dda.jpg
// module id = 259
// module chunks = 0